// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".common-skeleton-0a77e{position:fixed;width:100%;z-index:99999}.common-skeleton-0a77e *{animation:common-skeleton-loading-3f474 1.4s ease infinite;background:linear-gradient(90deg,hsla(0,0%,75%,.2) 25%,hsla(0,0%,51%,.24) 37%,hsla(0,0%,75%,.2) 63%);background-size:400% 100%}@keyframes common-skeleton-loading-3f474{0%{background-position:100% 50%}to{background-position:0 50%}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"skeleton": "common-skeleton-0a77e",
	"skeleton-loading": "common-skeleton-loading-3f474",
	"skeletonLoading": "common-skeleton-loading-3f474"
};
export default ___CSS_LOADER_EXPORT___;
